import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import cameraIcon from '../Icons/camara.jpg';
import { useFollowing } from '../context/FollowingContext';
import './RecommendedUsers.css';

const RecommendedUsers = ({ users, title = 'Perfiles recomendados' }) => {
    const navigate = useNavigate();
    const { followUser } = useFollowing();
    const scrollRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    // Detecta qué tarjeta está más cerca del centro del scroll
    const updateActive = useCallback(() => {
        const container = scrollRef.current;
        if (!container) return;
        const cards = container.querySelectorAll('.rec-user-card');
        if (!cards.length) return;
        const containerCenter = container.scrollLeft + container.offsetWidth / 2;
        let closest = 0;
        let minDist = Infinity;
        cards.forEach((card, i) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const dist = Math.abs(cardCenter - containerCenter);
            if (dist < minDist) { minDist = dist; closest = i; }
        });
        setActiveIndex(closest);
    }, []);

    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;
        container.addEventListener('scroll', updateActive, { passive: true });
        // Inicializar en la primera tarjeta
        updateActive();
        return () => container.removeEventListener('scroll', updateActive);
    }, [updateActive, users]);

    const handleFollow = (e, targetId) => {
        e.stopPropagation();
        followUser(targetId);
    };

    return (
        <div className="rec-users-container">
            <h4 className="rec-users-title">{title}</h4>
            {!users || users.length === 0 ? (
                <p className="rec-users-empty">No hay cuentas recomendadas para ti por ahora.</p>
            ) : (
                <div className="rec-users-scroll" ref={scrollRef}>
                    {users.map((user, idx) => (
                        <div
                            key={user.id}
                            className={`rec-user-card${idx === activeIndex ? ' rec-user-card--active' : ' rec-user-card--inactive'}`}
                            onClick={() => navigate(`/profile/${user.id}`)}
                        >
                            <span className="rec-user-name">
                                {(user.displayName || user.name || user.userName || '').slice(0, 12) || '—'}
                            </span>
                            <img
                                src={user.profileImage || cameraIcon}
                                alt={user.displayName || ''}
                                className="rec-user-avatar"
                                onError={e => { e.target.src = cameraIcon; }}
                            />
                            {user.recipeImages?.length > 0 && (
                                <div className="rec-user-recipes-grid">
                                    {user.recipeImages.slice(0, 4).map((img, i) => (
                                        <img key={i} src={img} alt="" className="rec-user-recipe-thumb"
                                            onError={e => { e.target.style.display = 'none'; }} />
                                    ))}
                                </div>
                            )}
                            <button
                                className="rec-user-follow-btn"
                                onClick={e => handleFollow(e, user.id)}
                            >
                                + Seguir
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RecommendedUsers;

